'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ContactListSidebar = (_dec = (0, _mobxReact.inject)('UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(ContactListSidebar, _Component);

  function ContactListSidebar() {
    _classCallCheck(this, ContactListSidebar);

    return _possibleConstructorReturn(this, (ContactListSidebar.__proto__ || Object.getPrototypeOf(ContactListSidebar)).apply(this, arguments));
  }

  _createClass(ContactListSidebar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          changeFilters = _props.changeFilters,
          entityName = _props.entityName,
          contactListPage = _props.UiStore.contactListPage;

      return _react2.default.createElement(
        'div',
        { className: 'wrapper' },
        _react2.default.createElement(
          'h3',
          null,
          entityName,
          ' Search'
        ),
        _react2.default.createElement(_common.ListSearchFilter, { pageStore: contactListPage, onInputChange: changeFilters })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ContactListSidebar;
}(_react.Component), _class2.propTypes = {
  changeFilters: _propTypes2.default.func.isRequired,
  entityName: _propTypes2.default.string.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = ContactListSidebar;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ContactListSidebar, 'ContactListSidebar', '/app/src/components/page-contacts/ContactListSidebar.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-contacts/ContactListSidebar.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY29udGFjdHMvQ29udGFjdExpc3RTaWRlYmFyLmpzIl0sIm5hbWVzIjpbIkNvbnRhY3RMaXN0U2lkZWJhciIsImF1dG9CaW5kTWV0aG9kcyIsIm9ic2VydmVyIiwicHJvcHMiLCJjaGFuZ2VGaWx0ZXJzIiwiZW50aXR5TmFtZSIsImNvbnRhY3RMaXN0UGFnZSIsIlVpU3RvcmUiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJmdW5jIiwiaXNSZXF1aXJlZCIsInN0cmluZyIsIm9iamVjdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOztBQUVBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBTU1BLGtCLFdBSEwsdUJBQU8sU0FBUCxDLG9CQUNBQyxnQyxlQUNBQyxtQjs7Ozs7Ozs7Ozs7NkJBR1c7QUFBQSxtQkFDNEQsS0FBS0MsS0FEakU7QUFBQSxVQUNBQyxhQURBLFVBQ0FBLGFBREE7QUFBQSxVQUNlQyxVQURmLFVBQ2VBLFVBRGY7QUFBQSxVQUNzQ0MsZUFEdEMsVUFDMkJDLE9BRDNCLENBQ3NDRCxlQUR0Qzs7QUFFUixhQUNFO0FBQUE7QUFBQSxVQUFLLFdBQVUsU0FBZjtBQUNFO0FBQUE7QUFBQTtBQUFLRCxvQkFBTDtBQUFBO0FBQUEsU0FERjtBQUVFLHNDQUFDLHdCQUFELElBQWtCLFdBQVdDLGVBQTdCLEVBQThDLGVBQWVGLGFBQTdEO0FBRkYsT0FERjtBQU1EOzs7Ozs7Ozs7OztFQVY4QkksZ0IsV0FZeEJDLFMsR0FBWTtBQUNqQkwsaUJBQWVNLG9CQUFVQyxJQUFWLENBQWVDLFVBRGI7QUFFakJQLGNBQVlLLG9CQUFVRyxNQUFWLENBQWlCRCxVQUZaO0FBR2pCTCxXQUFTRyxvQkFBVUksTUFBVixDQUFpQkY7QUFIVCxDO2VBT05aLGtCOzs7Ozs7Ozs7OzswQkFuQlRBLGtCIiwiZmlsZSI6IkNvbnRhY3RMaXN0U2lkZWJhci5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5pbXBvcnQgeyBpbmplY3QsIG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCc7XG5cbmltcG9ydCB7IExpc3RTZWFyY2hGaWx0ZXIgfSBmcm9tICcuLi9jb21tb24nO1xuXG5cbkBpbmplY3QoJ1VpU3RvcmUnKVxuQGF1dG9CaW5kTWV0aG9kc1xuQG9ic2VydmVyXG5jbGFzcyBDb250YWN0TGlzdFNpZGViYXIgZXh0ZW5kcyBDb21wb25lbnQge1xuXG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3QgeyBjaGFuZ2VGaWx0ZXJzLCBlbnRpdHlOYW1lLCBVaVN0b3JlOiB7IGNvbnRhY3RMaXN0UGFnZSB9IH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT0nd3JhcHBlcic+XG4gICAgICAgIDxoMz57ZW50aXR5TmFtZX0gU2VhcmNoPC9oMz5cbiAgICAgICAgPExpc3RTZWFyY2hGaWx0ZXIgcGFnZVN0b3JlPXtjb250YWN0TGlzdFBhZ2V9IG9uSW5wdXRDaGFuZ2U9e2NoYW5nZUZpbHRlcnN9IC8+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG5cbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICBjaGFuZ2VGaWx0ZXJzOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICAgIGVudGl0eU5hbWU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgICBVaVN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhY3RMaXN0U2lkZWJhcjtcbiJdfQ==